import { render, staticRenderFns } from "./payment-type-method.vue?vue&type=template&id=51c9118d"
import script from "./payment-type-method.vue?vue&type=script&lang=js"
export * from "./payment-type-method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports